var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"personal"},[(_vm.user)?_c('orders-menu'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"inner-body-block"},[_c('nuxt-child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }